var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhanHePrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 10,
    fill: "#0F34CE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33083_161038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 21.797V25.2594C34 27.109 32.9398 28.6316 31.6429 28.6316H30.9323V29.8158C30.9323 31.8459 29.2744 33.5038 27.2444 33.5038H26.1729C26.0263 34.1015 25.485 34.5414 24.8534 34.5414H22.3383C21.594 34.5414 20.9737 33.9323 20.9737 33.1767V32.6015C20.9737 31.8571 21.5827 31.2368 22.3383 31.2368H24.8534C25.485 31.2368 26.0263 31.6767 26.1729 32.2632H27.2444C28.5977 32.2632 29.6917 31.1579 29.6917 29.8158V28.6316H28.5526C28.1692 28.6316 27.8534 28.1917 27.8534 27.6391V19.4173C27.8534 18.8647 28.1692 18.4248 28.5526 18.4248H28.7218V17.9737C28.7218 14.7932 26.1391 12.2105 22.9586 12.2105H21.1541C17.9737 12.2105 15.391 14.7932 15.391 17.9737V18.4248H15.4474C15.8308 18.4248 16.1466 18.8759 16.1466 19.4173V27.6391C16.1466 28.1917 15.8308 28.6316 15.4474 28.6316H12.3571C11.0602 28.6316 10 27.109 10 25.2594V21.797C10 19.9474 11.0602 18.4248 12.3571 18.4248H12.6391V17.9737C12.6391 13.282 16.4624 9.45865 21.1541 9.45865H22.9586C27.6504 9.45865 31.4737 13.282 31.4737 17.9737V18.4248H31.6429C32.9398 18.4135 34 19.9361 34 21.797Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33083_161038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25.0827,
    fill: "white",
    transform: "translate(10 9.45865)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhanHePrm);
export default __webpack_public_path__ + "static/media/PhanHePRM.d8f8d3dc.svg";
export { ForwardRef as ReactComponent };